import { Children, type ReactElement, type ReactNode } from 'react'
import { Box } from '../../Box'
import { Row } from '../../Row'
import { TextWithCapsize as Text, type TextWithCapsizeProps } from '../../Text'
import { withNoLinesCss } from '../../Text/Text.css'
import { useSelectContext } from './hooks/useSelectContext'
import type { OptionProps, Option } from './Option'

/** @deprecated */
export type LabelVariants = 'value' | 'label+value' | 'label'
/** @deprecated */
export type LabelProps<T> = {
  children: ReactNode
  variant: LabelVariants
  items: Array<ReactElement<OptionProps<T>, typeof Option<T>>>
  size: TextWithCapsizeProps['size']
}

function wrapChildrenWithText(
  children: ReactNode,
  size: TextWithCapsizeProps['size'],
) {
  return Children.map(children, (child, index) => {
    if (typeof child === 'string') {
      return (
        <Text variant={null} width="100%" key={index} size={size}>
          <Box className={withNoLinesCss} display="block" as="span">
            {child}
          </Box>
        </Text>
      )
    }

    return child
  })
}

/** @deprecated */
export function Label<T>({ children, items, variant, size }: LabelProps<T>) {
  const { selected } = useSelectContext()

  let renderedLabel: ReactNode = wrapChildrenWithText(children, size)
  if (variant !== 'label') {
    if (selected.size > 0) {
      const selectedItems = items.filter((item) =>
        selected.has(item.props.value),
      )

      const renderedItems = selectedItems.map((item) => {
        return wrapChildrenWithText(item.props.children, size)
      })
      if (variant === 'label+value') {
        renderedLabel = (
          <Row minWidth="0" gap="l" flexGrow="1">
            <Row start gap="2x" fixWhiteSpace>
              {wrapChildrenWithText(children, size)}
            </Row>
            <Row start gap="2x" fixWhiteSpace color="foreground" minWidth="0">
              {renderedItems}
            </Row>
          </Row>
        )
      } else {
        if (selectedItems.length > 0) {
          renderedLabel = renderedItems
        }
      }
    }
  }

  return renderedLabel
}
